<template>
  <iColumn align="center" gap="none">
    <iRow vertical-align="middle" width="hug">
      <iText>Powered by</iText>
    </iRow>
    <iRow vertical-align="middle" width="hug">
      <iImageContainer :src="logoSrc" :height="24" :style-overrides="{backgroundColor: 'none'}" />
    </iRow>
  </iColumn>
</template>

<script>
import { useStyleStore } from "@vcl";

const LIGHT_LOGO = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/logos/svg/black-green.svg";
const DARK_LOGO = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/logos/svg/white-green.svg";

export default {
  name: "PoweredByInspiration",
  computed: {
    logoSrc() {
      const styleStore = useStyleStore();
      const mode = styleStore.getThemeMode(styleStore.DEFAULT_THEME_ID);
      return mode === "dark-mode" ? DARK_LOGO : LIGHT_LOGO;
    },
  },
};
</script>
